/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Product_Load_ErrorInputs */

const vi_pos_product_load_error = /** @type {(inputs: Pos_Product_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi tải sản phẩm. Vui lòng tải lại trang.`)
};

/**

* @param {Pos_Product_Load_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_product_load_error = /** @type {((inputs?: Pos_Product_Load_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Product_Load_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_product_load_error(inputs)
});